import { TextOverflow } from '@ardoq/popovers';
import { DecoratorWrapper } from './atoms';
import { EntityIcon, EntityIconProps } from '@ardoq/basic-components';
import { LinkDecorator, LinkDecoratorProps } from './LinkDecorator';
import { CircleIcon, IconSize } from '@ardoq/icons';

export type ComponentDecoratorProps = {
  label?: string;
  labelColor?: string;
  useDefaultIcon?: boolean;
} & Omit<EntityIconProps, 'style'> &
  Omit<LinkDecoratorProps, 'hideIcon' | 'children'>;

export const ComponentDecorator = ({
  label,
  labelColor,
  onClick,
  href,
  imageSrc,
  shapeId,
  iconId,
  color,
  useDefaultIcon = false,
  ...linkProps
}: ComponentDecoratorProps) => {
  const replaceIconWithDefault =
    iconId === 'none' && !shapeId && !imageSrc && useDefaultIcon;

  return (
    <DecoratorWrapper $skipIconColor>
      {!replaceIconWithDefault ? (
        <EntityIcon
          imageSrc={imageSrc}
          iconId={iconId}
          shapeId={shapeId}
          color={color}
        />
      ) : (
        <CircleIcon iconSize={IconSize.SMALL} color={color} />
      )}

      {label && (
        <>
          {onClick || href ? (
            <LinkDecorator
              hideIcon
              onClick={onClick}
              href={href}
              {...linkProps}
            >
              <TextOverflow renderIn="popover" style={{ color: labelColor }}>
                {label}
              </TextOverflow>
            </LinkDecorator>
          ) : (
            <TextOverflow renderIn="popover" style={{ color: labelColor }}>
              {label}
            </TextOverflow>
          )}
        </>
      )}
    </DecoratorWrapper>
  );
};
